// extracted by mini-css-extract-plugin
export default {"img":"GigsCount_img__KMWuG"};